(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accessorize"] && !Shopify.designMode) return;
  try {
    
/* Intentionally left empty: inline script already added */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-benefit-policy"] && !Shopify.designMode) return;
  try {
    
/* Reserved for any future JS (currently none needed) */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-maximum-savings"] && !Shopify.designMode) return;
  try {
    
  /* 功能脚本已内联，可按需迁移 */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-new-song"] && !Shopify.designMode) return;
  try {
    
  // Set attribute for Black Friday page styling
  document.addEventListener('DOMContentLoaded', function() {
    if (window.location.pathname.includes('/pages/black-friday') || window.location.pathname.includes('/pages/christmas-sales')) {
      const footers = document.querySelectorAll('.footer-new, .footer-new-mobile');
      footers.forEach(function(footer) {
        footer.setAttribute('data-black-friday-page', 'true');
      });
      
      // Change footer mobile subscribe button text and behavior
      const subscribeBtn = document.querySelector('.footer-mobile__subscribe-btn');
      if (subscribeBtn) {
        subscribeBtn.textContent = 'Get Your Discount Now !';
        
        // Add click event to scroll to top
        subscribeBtn.addEventListener('click', function(e) {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video-banner"] && !Shopify.designMode) return;
  try {
    
document.querySelector(".hero-video-banner").onclick='https://www.9amhome.com/collections/standing-desks';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-carousel"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initAllCarousels() {
    document.querySelectorAll('.logo-carousel-section').forEach(function(section) {
      section.querySelectorAll('.lc-row').forEach(function(row) {
        var track = row.querySelector('.lc-track');
        if (!track) return;

        var rowWidth = row.offsetWidth;
        var originalItems = Array.from(track.querySelectorAll('.lc-logo:not(.lc-logo--clone)'));

        if (originalItems.length === 0) return;

        // 克隆直到总宽度 >= 2倍行宽度，确保无缝铺满全屏
        while (track.scrollWidth < rowWidth * 2) {
          originalItems.forEach(function(item) {
            var clone = item.cloneNode(true);
            clone.classList.add('lc-logo--clone');
            track.appendChild(clone);
          });
        }

        // 恢复动画
        track.classList.add('lc-track--ready');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCarousels);
  } else {
    initAllCarousels();
  }

  // Resize 时重新计算补充
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      document.querySelectorAll('.logo-carousel-section').forEach(function(section) {
        section.querySelectorAll('.lc-row').forEach(function(row) {
          var track = row.querySelector('.lc-track');
          if (!track) return;
          var rowWidth = row.offsetWidth;
          var originalItems = Array.from(track.querySelectorAll('.lc-logo:not(.lc-logo--clone)'));
          if (originalItems.length === 0) return;
          while (track.scrollWidth < rowWidth * 2) {
            originalItems.forEach(function(item) {
              var clone = item.cloneNode(true);
              clone.classList.add('lc-logo--clone');
              track.appendChild(clone);
            });
          }
        });
      });
    }, 250);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nmm-9am-mega-menu"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeMegaMenu = (root) => {
      if (!root || root.dataset.nmm9amReady === 'true') return;
      root.dataset.nmm9amReady = 'true';

      const menuToggle = root.querySelector('[data-nmm-9am-menu-toggle]');
      const panel = root.querySelector('[data-nmm-9am-panel]');
      const mobileToggle = root.querySelector('[data-nmm-9am-mobile-toggle]');
      const mainNavigation = root.querySelector('[data-nmm-9am-main-nav]');

      if (menuToggle && panel) {
        menuToggle.addEventListener('click', () => {
          const willOpen = menuToggle.getAttribute('aria-expanded') !== 'true';
          menuToggle.setAttribute('aria-expanded', String(willOpen));
          panel.hidden = !willOpen;
        });
      }

      if (mobileToggle && mainNavigation) {
        mobileToggle.addEventListener('click', () => {
          const willOpen = mobileToggle.getAttribute('aria-expanded') !== 'true';
          mobileToggle.setAttribute('aria-expanded', String(willOpen));
          mobileToggle.setAttribute('aria-label', willOpen ? 'Close menu' : 'Open menu');
          mainNavigation.classList.toggle('nmm-9am-mega__main-nav--open', willOpen);
        });
      }

      root.querySelectorAll('[data-nmm-9am-slider]').forEach((slider) => {
        const track = slider.querySelector('[data-nmm-9am-track]');
        const previous = slider.querySelector('[data-nmm-9am-prev]');
        const next = slider.querySelector('[data-nmm-9am-next]');
        if (!track || !previous || !next) return;

        const move = (direction) => {
          const card = track.querySelector('.nmm-9am-mega__card');
          const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
          const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
          track.scrollBy({ left: direction * distance, behavior: 'smooth' });
        };

        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
      });
    };

    document.querySelectorAll('[data-nmm-9am-mega]').forEach(initializeMegaMenu);
    document.addEventListener('shopify:section:load', (event) => {
      initializeMegaMenu(event.target.querySelector('[data-nmm-9am-mega]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["safety-feature-cards"] && !Shopify.designMode) return;
  try {
    
  class SafetyFeatureCards {
    constructor(root) {
      this.root = root;
      this.cards = Array.from(root.querySelectorAll('.safety-features__card'));
      this.io = null;
    }

    init() {
      if (!this.root || this.cards.length === 0) return;
      this.applyHeights();
      this.bindResponsiveListener();
      this.observeCards();
    }

    applyHeights() {
      if (window.innerWidth > 767 && this.cards.length === 2) {
        const tallest = Math.max(...this.cards.map((card) => card.offsetHeight));
        this.cards.forEach((card) => {
          card.style.minHeight = `${tallest}px`;
        });
      } else {
        this.cards.forEach((card) => {
          card.style.minHeight = '';
        });
      }
    }

    bindResponsiveListener() {
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => this.applyHeights(), 120);
      });
    }

    observeCards() {
      if (!('IntersectionObserver' in window)) return;
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('safety-features__card--in-view');
            this.io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });
      this.cards.forEach((card) => this.io.observe(card));
    }
  }

  function mountSafetyFeatureCards(root) {
    if (!root || root.dataset.sfcMounted === '1') return;
    const instance = new SafetyFeatureCards(root);
    instance.init();
    root.dataset.sfcMounted = '1';
  }

  function bootstrapSafetyFeatureCards() {
    document.querySelectorAll('[data-section-type="safety-feature-cards"]').forEach(mountSafetyFeatureCards);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrapSafetyFeatureCards);
  } else {
    bootstrapSafetyFeatureCards();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target.querySelector('[data-section-type="safety-feature-cards"]');
    if (target) {
      target.dataset.sfcMounted = '';
      mountSafetyFeatureCards(target);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["workspace-solution"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ws-section').forEach(function(sectionEl) {
  var container = sectionEl.querySelector('.ws__cards');
  var dotsWrap = sectionEl.querySelector('.ws__dots');
  if (!container || !dotsWrap) return;

  var dots = dotsWrap.querySelectorAll('.ws__dot');
  var cards = container.querySelectorAll('.ws__card');
  if (cards.length <= 1) { dotsWrap.style.display = 'none'; return; }

  function getGap() {
    var style = window.getComputedStyle(container);
    return parseFloat(style.gap) || 0;
  }

  function getActiveIndex() {
    var gap = getGap();
    var cardW = cards[0].offsetWidth;
    var step = cardW + gap;
    if (step <= 0) return 0;
    var idx = Math.round(container.scrollLeft / step);
    return Math.max(0, Math.min(idx, dots.length - 1));
  }

  function updateDots() {
    var active = getActiveIndex();
    dots.forEach(function(dot, i) {
      dot.classList.toggle('active', i === active);
    });
  }

  container.addEventListener('scroll', updateDots, { passive: true });
  window.addEventListener('resize', updateDots);

  dots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      var idx = parseInt(this.getAttribute('data-index'), 10);
      var gap = getGap();
      var step = cards[0].offsetWidth + gap;
      container.scrollTo({ left: idx * step, behavior: 'smooth' });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
